import { render, staticRenderFns } from "./agent-assistance.vue?vue&type=template&id=e5a7a03c&scoped=true&"
import script from "./agent-assistance.vue?vue&type=script&lang=js&"
export * from "./agent-assistance.vue?vue&type=script&lang=js&"
import style0 from "./agent-assistance.vue?vue&type=style&index=0&id=e5a7a03c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a7a03c",
  null
  
)

export default component.exports